export default "__VITE_ASSET__CYpFYg$Q__"